import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross Blue Shield of New Mexico",
  shortName: "BCBSNM",
  slug: "bcbsnm-insurance",
  seoTitle:
    "Blue Cross Blue Shield of New Mexico (BCBSNM) TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross Blue Shield of New Mexico (BCBSNM) policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "BCBSNM TMS coverage, Blue Cross Blue Shield New Mexico SPRAVATO authorization, BCBSNM mental health benefits Coral Springs FL, BCBSNM depression treatment Florida",
};

export const BcbsnmInsurance = () => <InsurancePageTemplate config={config} />;
export default BcbsnmInsurance;
